import axios from 'axios'
import {useQuery} from 'react-query'
import {API_URL} from 'src/cms/constants/EndPoint'

const QUERY_KEY = 'getDashboardData'

export const useGetDashboardData = (modelName: any) => {
  return useQuery(
    [QUERY_KEY, modelName], // Including modelName in the query key
    async () => {
      const {data} = await axios.get(`${API_URL}/dashboard`, {
        params: {
          model_name: modelName,
        },
        headers: {
          Accept: 'application/json',
        },
      })
      return data
    },
    {
      onError: (error) => {
        console.error('Error fetching dashboard data:', error)
      },
    }
  )
}
